import {
  CAREER_MENTOR_MESSAGE_TEMPLATE,
  CareerMentorActiveMessageParams
} from './career-mentor-service-types'

export const buildActiveMessageBody = (params: CareerMentorActiveMessageParams) => {
  const templateName =
    params.searchTerm &&
    params.templateName === CAREER_MENTOR_MESSAGE_TEMPLATE.CONTACT_REQUEST_FROM_SEARCH
      ? CAREER_MENTOR_MESSAGE_TEMPLATE.CONTACT_REQUEST_FROM_SEARCH
      : CAREER_MENTOR_MESSAGE_TEMPLATE.CONTACT_REQUEST

  const args: Record<string, string> = { language: params.language }
  if (params.searchTerm) args['search_term'] = params.searchTerm

  return { template_name: templateName, args }
}
